import { SET_PUBLISHER_ID } from "../types";

export const setPublisherId = item => ({
  type: SET_PUBLISHER_ID,
  payload: item,
});
